<template>
  <div
      class="products-list__item"
      :style="productStyle"
      @click="onProductSelected"
  >
    <div
        class="products-list__item__description"
        :style="labelStyle"
    >
      {{product.DESCRIPCION}}
    </div>
    <span
        class="badge badge-info products-list__item__price"
        v-if="showPrecio"
    >{{Number(product.PVP).toFixed(2)}}€</span>
  </div>
</template>
<script>
  export default {
    props: {
      product: {type: Object},
    },
    computed: {
      showPrecio() {
        const inc = Number(this.product.PVP)
        return inc !== 0
      },
      precio() {
        let inc = Number(this.product.PVP)
        return `${inc.toFixed(2)}€`
      },
      labelStyle() {
        const {IMAGENURL} = this.product
        return IMAGENURL && {
          backgroundColor: 'rgba(52, 58, 64, .82)',
          bottom: 0,
          color: 'white',
          fontWeight: 'normal',
          left: 0,
          right: 0,
          padding: '.2rem .4rem',
          position: 'absolute',
        }
      },
      productStyle() {
        const {COLORFONDO, COLORTEXTO, IMAGENURL} = this.product

        if (IMAGENURL) return {
          background: `#bebebe url(${IMAGENURL}) center center`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }

        let colorFondo = '#' + this.getColor(Number(COLORFONDO))
        let colorTexto = '#' + this.getColor(Number(COLORTEXTO))

        if (colorFondo === '#000000') colorFondo = COLORFONDO
        if (colorTexto === '#000000') colorTexto = COLORTEXTO

        return {
          backgroundColor: colorFondo,
          color: colorTexto,
        }
      },
    },
    methods: {
      getColor: int => {
        let red = int >> 16
        let green = (int - (red << 16)) >> 8
        let blue = int - (red << 16) - (green << 8)
        let bin = (blue << 16) | (green << 8) | red
        return (function (h) {
          return new Array(7 - h.length).join('0') + h
        })(bin.toString(16).toUpperCase())
      },
      onProductSelected() {
        this.$emit('ProductSelected', this.product)
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Products/ProductsListItem.vue